import CoreUtils from './CoreUtils';
import StringUtils from './StringUtils';

const standardDataType = 'application/octet-stream';

export default class BlobUtils {
  static convertBlobToTypedDataUri(blob, blobDataType) {
    return new Promise((resolve, reject) => {
      if (CoreUtils.isUndefinedOrNull(blob)) {
        reject();
        return;
      }

      if (!(blob instanceof Blob)) {
        reject();
        return;
      }

      var fileReader = new FileReader();

      fileReader.onloadend = (event) => {
        var standardDataUri = event.currentTarget.result;
        var typedDataUri = standardDataUri.replace(standardDataType, blobDataType);

        resolve(typedDataUri);
      };
      fileReader.onerror = error => reject(error);
      fileReader.onabort = () => reject('aborted');

      fileReader.readAsDataURL(blob);
    });
  }

  static convertTypedDataUriToBlob(typedDataUri) {
    return new Promise((resolve, reject) => {
      if (!StringUtils.isNonEmptyString(typedDataUri)) {
        reject();
        return;
      }

      fetch(typedDataUri).then(
        fetchResponse => {
          fetchResponse.blob().then(
            blobResult => resolve(blobResult),
            blobError => reject(blobError)
          );
        },
        fetchError => reject(fetchError)
      );
    });
  }
}